import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteArtist } from "../api/artistsApi";
import { queryKeys } from "../lib/queryKeys";

export function useDeleteArtist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteArtist,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.artists.all });
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
      qc.invalidateQueries({ queryKey: queryKeys.parcours.all });
    },
  });
}
